import { render, staticRenderFns } from "./CASEItemAssociations.vue?vue&type=template&id=3743ceec"
import script from "./CASEItemAssociations.vue?vue&type=script&lang=js"
export * from "./CASEItemAssociations.vue?vue&type=script&lang=js"
import style0 from "./CASEItemAssociations.vue?vue&type=style&index=0&id=3743ceec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports